import { initReact } from '../../../Shared/js/vendor/react';
import * as MobilePhonesComponents from './components';

function initMobilePhonesComponents() {
    initReact();
    window.MobilePhonesComponents = window.MobilePhonesComponents || MobilePhonesComponents;
}

initMobilePhonesComponents();
